(() => {
  'use strict';
  window.dataLayer = window.dataLayer || [];

  const selectedVariant = (root) => {
    const params = new URL(window.location.href).searchParams;
    const fromUrl = root.dataset.compareHub === 'true' ? params.get('a') : params.get('variant');
    return fromUrl || root.dataset.initialVariant;
  };

  const initialize = (root) => {
    if (root.dataset.compareInitialized === 'true') return;
    root.dataset.compareInitialized = 'true';
    const jump = root.closest('[data-section-type="product"]')?.querySelector('[data-compare-jump]');
    const settleCompare = () => {
      let canceled = false;
      let attempts = 0;
      const cancel = () => { canceled = true; };
      ['wheel', 'touchstart', 'keydown', 'pointerdown'].forEach((type) => {
        window.addEventListener(type, cancel, { once: true, passive: true });
      });
      const align = () => {
        if (canceled || root.hidden) return;
        const offset = parseFloat(getComputedStyle(root).scrollMarginTop) || 0;
        if (Math.abs(root.getBoundingClientRect().top - offset) > 24) {
          root.scrollIntoView({ block: 'start', behavior: 'instant' });
        }
        if (++attempts < 20) setTimeout(align, 250);
      };
      align();
    };
    if (jump) jump.addEventListener('click', (event) => {
      event.preventDefault();
      root.focus({ preventScroll: true });
      settleCompare();
    });
    const panels = [...root.querySelectorAll('[data-compare-variant]')];
    const seen = new Set();
    let current = null;

    const activePartner = (panel) => panel.querySelector('[data-compare-partner]:not([hidden])');
    const eventContext = (panel) => {
      const pair = activePartner(panel);
      const source = pair?.querySelector('[data-compare-card]');
      const alternative = pair?.querySelectorAll('[data-compare-card]')[1];
      return {
        source_variant_id: panel.dataset.compareVariant,
        comparison_variant_id: pair?.dataset.comparePartner || null,
        compare_group: panel.dataset.compareGroup || '',
        source_price_cents: source ? Number(source.dataset.comparePriceCents) : null,
        comparison_price_cents: alternative ? Number(alternative.dataset.comparePriceCents) : null
      };
    };
    const recordView = () => {
      if (!current || current.hidden || !current.getClientRects().length) return;
      const key = current.dataset.compareVariant + ':' + (activePartner(current)?.dataset.comparePartner || '');
      if (seen.has(key)) return;
      const rect = current.getBoundingClientRect();
      if (rect.bottom <= 0 || rect.top >= window.innerHeight) return;
      seen.add(key);
      window.dataLayer.push({ event: 'compare_viewed', ...eventContext(current) });
    };
    const showVariant = (id) => {
      current = null;
      panels.forEach((panel) => {
        panel.hidden = panel.dataset.compareVariant !== String(id);
        if (!panel.hidden) current = panel;
      });
      root.hidden = !current;
      const wrapper = root.closest('.product-block-list__item--jootti-compare');
      if (wrapper) wrapper.hidden = !current;
      if (jump) {
        jump.hidden = !current || current.dataset.comparePublished !== 'true';
        if (!jump.hidden) {
          const label = jump.querySelector('[data-compare-jump-label]');
          if (label) {
            const isReel = current.dataset.compareGroup === 'baitcasting' || current.dataset.compareGroup === 'spinning';
            label.textContent = isReel ? label.dataset.reelLabel : label.dataset.rodLabel;
          }
        }
      }
      recordView();
    };

    root.addEventListener('change', (event) => {
      const select = event.target.closest('[data-compare-switch]');
      if (!select) return;
      const panel = select.closest('[data-compare-variant]');
      panel.querySelectorAll('[data-compare-partner]').forEach((pair) => {
        pair.hidden = pair.dataset.comparePartner !== select.value;
      });
      const pair = activePartner(panel);
      if (pair) {
        const introPrice = panel.querySelector('[data-compare-intro-price]');
        const introBest = panel.querySelector('[data-compare-intro-best]');
        if (introPrice) introPrice.textContent = pair.dataset.partnerPrice || '';
        if (introBest) introBest.textContent = pair.dataset.partnerBest || '';
        const cardLink = pair.querySelector('[data-compare-card]:last-child .jootti-compare__view');
        const shopB = panel.querySelector('[data-compare-shop-b]');
        if (cardLink && shopB) {
          shopB.href = cardLink.href;
          const title = pair.querySelector('[data-compare-card]:last-child .jootti-compare__card-title');
          const nameParts = [...(title?.querySelectorAll('.jootti-compare__identity-series,.jootti-compare__identity-model') || [])]
            .map((part) => part.textContent.trim()).filter(Boolean);
          const productName = nameParts.length ? nameParts.join(' · ') : title?.textContent?.trim();
          shopB.setAttribute('aria-label', productName ? 'Shop exact product B: ' + productName : 'Shop exact product B');
          shopB.textContent = productName ? 'SHOP B · ' + productName : 'SHOP PRODUCT B';
        }
      }
      recordView();
    });
    root.addEventListener('click', (event) => {
      const another = event.target.closest('[data-compare-another]');
      if (another) {
        const chooser = another.closest('[data-compare-variant]')?.querySelector('[data-compare-switch]');
        if (chooser) {
          chooser.scrollIntoView({ block: 'center', behavior: 'smooth' });
          chooser.focus({ preventScroll: true });
        }
        return;
      }
      const link = event.target.closest('[data-compare-link]');
      if (!link) return;
      const panel = link.closest('[data-compare-variant]');
      window.dataLayer.push({ event: 'compare_alternative_clicked', ...eventContext(panel) });
    });
    document.addEventListener('variant:changed', (event) => {
      if (event.detail?.variant?.id) showVariant(event.detail.variant.id);
    });
    window.addEventListener('popstate', () => showVariant(selectedVariant(root)));
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(recordView, { threshold: 0.1 });
      observer.observe(root);
    } else {
      window.addEventListener('scroll', recordView, { passive: true });
    }
    showVariant(selectedVariant(root));
    if (window.location.hash === '#jootti-compare') {
      const settleHash = () => requestAnimationFrame(() => {
        if (root.hidden) return;
        root.focus({ preventScroll: true });
        settleCompare();
      });
      if (document.readyState === 'complete') settleHash();
      else window.addEventListener('load', settleHash, { once: true });
    }
  };
  document.querySelectorAll('[data-jootti-compare]').forEach(initialize);
  window.JoottiCompare = window.JoottiCompare || {};
  window.JoottiCompare.mount = initialize;
})();
